// extracted by mini-css-extract-plugin
module.exports = {"lineupTable":"LineupSingle_lineupTable_1wjjU","playerTooltip":"LineupSingle_playerTooltip_303SF"};